import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationWidgetGitService } from './visualization-widget-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationWidgetGitFactoryService extends AbstractGitFactoryService<VisualizationWidgetGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationWidgetGitService,
    });
  }
}
